(function($) {

    var menuLangToggler = $(".menu-language-toggler");

    menuLangToggler.click(function () {

        $(this).toggleClass("menu-language-toggler--opened");
        $(".menu-language-wrapper").toggleClass("menu-language-wrapper--opened");

        if(menuLangToggler.attr("aria-expanded") === "true") {
            menuLangToggler.attr("aria-expanded", "false")
        } else {
            menuLangToggler.attr("aria-expanded", "true")
        }
    });


})(jQuery);
